import { badmintonRallyV1Module } from "./badmintonRallyV1Module";

/** @type {Map<string, import('../../domain/cmoe/activity/activityModuleContract').ActivityModule>} */
const registry = new Map();

function moduleKey(moduleId, moduleVersion) {
  return `${moduleId}@${moduleVersion}`;
}

export function registerActivityModule(module) {
  registry.set(moduleKey(module.moduleId, module.moduleVersion), module);
}

export function getActivityModule(moduleId, moduleVersion) {
  return registry.get(moduleKey(moduleId, moduleVersion)) || null;
}

export function listActivityModules() {
  return [...registry.values()];
}

registerActivityModule(badmintonRallyV1Module);

export { badmintonRallyV1Module };
